<script setup lang="ts">
/**
 * CampaignCreator — bloc "créateur" (logo + nom de l'organisation + date de
 * lancement), cliquable vers la page asso.
 *
 * Composant PARTAGÉ (@donoor/ui) consommé en SOURCE par dashboard.donoor.org
 * et donoor.org. Couleurs en hex en dur (pas de token de thème) → rendu
 * identique dans les 2 apps.
 *
 * `<NuxtLink>` reste global (résolu par l'app Nuxt qui transpile ce SFC via
 * build.transpile).
 *
 * USAGE (auto-import via wrapper local) :
 *   import CampaignCreator from "@donoor/ui/campaign/CampaignCreator.vue";
 *
 * Karim 2026-06-21 (factorisation cagnotte).
 */
defineProps<{
  organizationLogo: string | null;
  organizationName: string;
  organizationSlug?: string | null;
  launchDateText?: string | null;
}>();
</script>

<template>
  <!-- `max-w-full min-w-0` : sans eux, le lien (inline-flex) prenait la
       largeur du nom et sortait de sa colonne avec un nom d'association long
       — le `truncate` du nom ne s'appliquait jamais (Karim 2026-10-08). Le nom
       passe sur 2 lignes au plus, le nom complet reste au survol. -->
  <NuxtLink
    :to="organizationSlug ? `/associations/${organizationSlug}` : undefined"
    class="inline-flex items-center gap-3 group max-w-full min-w-0"
    :class="{ 'pointer-events-none': !organizationSlug }"
    :title="organizationName"
  >
    <div
      class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden shrink-0"
    >
      <img
        v-if="organizationLogo"
        :src="organizationLogo"
        :alt="organizationName"
        class="w-full h-full object-cover"
      />
      <span v-else class="text-gray-500 text-sm font-bold">
        {{ organizationName.charAt(0).toUpperCase() }}
      </span>
    </div>
    <div class="min-w-0">
      <p class="font-bold text-[15px] text-gray-900 group-hover:underline line-clamp-2 wrap-break-word">
        {{ organizationName }}
      </p>
      <p v-if="launchDateText" class="text-xs text-gray-500 truncate">
        {{ launchDateText }}
      </p>
    </div>
  </NuxtLink>
</template>
